import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=03e23fe3"
import script from "./NotificationHandler.vue?vue&type=script&lang=js"
export * from "./NotificationHandler.vue?vue&type=script&lang=js"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=03e23fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports